import React from 'react'
import Sidebar from '../../components/Sidebar'
import Navbar from '../../components/Navbar'
import EthernetFaultComponent from '../../components/EthernetFaultComponent/EthernetFaultComponent'

const EthernetFault = () => {
    return (
        <div>
            <div className='flex'>
                <div className='w-[15%]'>
                    <Sidebar />
                </div>
                <div>
                    <Navbar />
                    <EthernetFaultComponent/>
                </div>
            </div>
        </div>
    )
}

export default EthernetFault
